<template>
  <div class="container">
    <div class="per-button" @click="handleChange">
      {{ $t('lang.external.personal.content.one.返回') }}
    </div>
    <div class="header">
      <span> {{ $t('lang.external.personal.content.one.排行榜') }}</span>
    </div>
    <div>
      <el-table
        :data="tableData"
        style="width: 100%"
        :header-cell-style="tableHeader"
      >
        <el-table-column
          :label="$t('lang.external.personal.content.one.排名')"
          align="center"
          type="index"
          :formatter="hasBackFormat"
          width="200"
        >
          <template slot-scope="scope">
            <img
              :src="serverURL + 'images/1_big.png'"
              v-if="scope.$index === 0"
            />
            <img
              :src="serverURL + 'images/2_big.png'"
              v-else-if="scope.$index === 1"
            />
            <img
              :src="serverURL + 'images/3_big.png'"
              v-else-if="scope.$index === 2"
            />
            <span v-else>{{ scope.$index + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="stuName"
          :label="$t('lang.external.personal.content.one.姓名')"
          align="center"
        >
          <template slot-scope="scope">
            <el-avatar :size="60" @error="errorHandler">
              <img :src="scope.row.photo" />
            </el-avatar>
            <span class="avatar-name">{{ scope.row.stuName }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="spendSecond"
          :label="$t('lang.external.personal.content.one.耗时')"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="score"
          :label="$t('lang.external.personal.content.one.分数')"
          width="180"
          align="center"
        >
        </el-table-column>
      </el-table>
    </div>
    <el-row></el-row>
  </div>
</template>

<script>
import { ranking } from '@/api/personalCenter/index'
import { seconds_to_minutes } from '@/utils/timeFormat'
import Pagination from '@/components/common/Pagination.vue'
export default {
  name: 'rankingList',
  components: {
    Pagination,
  },
  props: [],
  data() {
    return {
      tableData: [],
    }
  },
  watch: {},
  computed: {
    serverURL() {
      return this.publicData.serverUrl
    },
  },
  created() {
    this.getRankingData()
  },
  mounted() {},
  methods: {
    errorHandler() {
      return true
    },
    tableHeader({ row, column, rowIndex, columnIndex }) {
      return 'color:#666666'
    },
    hasBackFormat(row, column) {
      console.log(row.hasBackFormat)
      console.log(column)
    },
    handleChange() {
      this.$emit('change', true)
      this.$store.commit('SET_CRUMBS', undefined)
    },
    getRankingData() {
      var course_id = this.$store.state.personal.course_id
      ranking(course_id).then((res) => {
        const { data } = res
        data.forEach((item) => {
          item.spendSecond = seconds_to_minutes(item.spendSecond)
        })
        this.tableData = data
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.container  {
  position: relative;
  width: 100%;
}
.header {
  height: 40px;
  background-color: #dce9f3;
  line-height: 40px;
}
.header span {
  width: 65px;
  height: 15px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #0c5893;
  line-height: 18px;
  margin-left: 26px;
}
.el-avatar > img {
  display: inline-block;
  height: 100%;
  vertical-align: middle;
  margin-bottom: 1rem;
}
.avatar-name {
  position: absolute;
  top: 40%;
  margin-left: 10px;
  letter-spacing: 4px;
}

.per-button {
  position: absolute;
  top: -40px;
  right: 0;
}
</style>